import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CrewContainer from '../../layouts-components__common-cases/crew-container';
import CommonTitle from '../../../common-components/common-title';

const TeamCustomer = ({ listTeamCustomer }) => {
    return (
        <div className="teboil-team__customer">
            <FullWrapper>
                <CommonTitle>Команда заказчика</CommonTitle>
                <CrewContainer container={listTeamCustomer} />
            </FullWrapper>
        </div>
    );
};

export default TeamCustomer;
